import { defineComponent as _defineComponent } from 'vue'
import isEmpty from 'lodash/isEmpty';
import { computed } from 'vue';

import { LEARN_MORE_BASE_LINK } from '@/components/Billing/billing-service.const';
//@ts-ignore
import { pluralize } from '@/utils/language-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionCreditsRequiredText',
  props: {
	action: { type: Object, required: true },
},
  setup(__props) {

const props = __props



const creditsConfiguration = computed(() => props.action.credits_configuration);
const hasCreditsConfiguration = computed(() => !isEmpty(creditsConfiguration.value));
const hasMultiCreditsConfiguration = computed(() => creditsConfiguration.value?.length > 1);

const firstCreditsConfiguration = computed(() => creditsConfiguration.value?.[0]);
const creditsCost = computed(() => firstCreditsConfiguration.value?.credits);
const creditsNoun = computed(() => firstCreditsConfiguration.value?.noun);
const creditsAmountPerNoun = computed(() => firstCreditsConfiguration.value?.amount);

return { __sfc: true,props, creditsConfiguration, hasCreditsConfiguration, hasMultiCreditsConfiguration, firstCreditsConfiguration, creditsCost, creditsNoun, creditsAmountPerNoun, LEARN_MORE_BASE_LINK, pluralize }
}

})